import React from "react";
import NameSphere from "./components/NameSphere";
const dummyWords = [
  "Word-1",
  "Word-2",
  "Word-3",
  "Word-4",
  "Word-5",
  "Word-6",
  "Word-7",
  "Word-8",
  "Word-9",
  "Word-10",
  "Word-11",
  "Word-12",
  "Word-13",
  "Word-14",
  "Word-15",
  "Word-16",
  "Word-17",
  "Word-18",
  "Word-19",
  "Word-20",
];
const App = () => {
  return (
    <div>
      {/* Example usage of NameSphere component */}
      <NameSphere
        count={5} // Number of words in each row/column on the sphere
        radius={15} // Radius of the sphere
        color="black" // Default color of words
        hoveredColor="lime" // Color of words when hovered
        words={dummyWords} // Array of words to display on the sphere
        width={"100%"} // Width of the canvas (you can use units like %, vh, vw, or px)
        height={"100vh"} // Height of the canvas (you can use units like %, vh, vw, or px)
      />
    </div>
  );
};

export default App;
